<template>
    <div>
        <h1>{{title}}</h1>
    </div>
</template>

<script>
    export const Info = {
      name: 'Mijn beschikbaarheid',
      path: 'beschikbaarheid'
    };

    export default {
      Info,
      props: {

      },
      data () {
        return {
          title: Info.name
        };
      },
      computed: {

      },
      methods: {

      }
    };
</script>
